import React from 'react';
import { PropTypes } from 'prop-types';
import { isBank, isAdmin, isOpd, isVerificator } from './localstorage';
import { Route, Redirect } from 'react-router-dom';


export class Bank extends React.Component {
    render() {
        const { component, exact, path } = this.props;
        return (
            <Route exact={exact}
                path={path}
                render={props => (
                    isBank() ? (
                        React.createElement(component, props)
                    ) : <Redirect to="/" />)
                } />
        )
    }
}

export class Opd extends React.Component {
    render() {
        const { component, exact, path } = this.props;
        return (
            <Route exact={exact}
                path={path}
                render={props => (
                    isOpd() ? (
                        React.createElement(component, props)
                    ) : <Redirect to="/" />)
                } />
        )
    }
}

export class Admin extends React.Component {
    render() {
        const { component, exact, path } = this.props;
        return (
            <Route exact={exact}
                path={path}
                render={props => (
                    isAdmin() ? (
                        React.createElement(component, props)
                    ) : <Redirect to="/" />)
                } />
        )
    }
}

export class Verificator extends React.Component {
    render() {
        const { component, exact, path } = this.props;
        return (
            <Route exact={exact}
                path={path}
                render={props => (
                    isVerificator() ? (
                        React.createElement(component, props)
                    ) : <Redirect to="/" />)
                } />
        )
    }
}

Bank.propTypes = {
    component: PropTypes.func.isRequired,
    exact: PropTypes.bool,
    path: PropTypes.string.isRequired,
    location: PropTypes.object
};

Admin.propTypes = {
    component: PropTypes.func.isRequired,
    exact: PropTypes.bool,
    path: PropTypes.string.isRequired,
    location: PropTypes.object
};

Opd.propTypes = {
    component: PropTypes.func.isRequired,
    exact: PropTypes.bool,
    path: PropTypes.string.isRequired,
    location: PropTypes.object
};

Verificator.propTypes = {
    component: PropTypes.func.isRequired,
    exact: PropTypes.bool,
    path: PropTypes.string.isRequired,
    location: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/_utils/Permission.js